var map = {
	"./empty.svg": [
		67515,
		"node_modules_raw-loader_dist_cjs_js_src_assets_Illustrations_empty_svg"
	],
	"./folder.svg": [
		76434,
		"node_modules_raw-loader_dist_cjs_js_src_assets_Illustrations_folder_svg"
	],
	"./images.svg": [
		80031,
		"node_modules_raw-loader_dist_cjs_js_src_assets_Illustrations_images_svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80608;
module.exports = webpackAsyncContext;